import { useState } from 'react';

function ReactModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Course Introduction",
      content: [
        "What is React?",
        "Introduction to React and its core concepts.",
        "Benefits of using React in web development.",
        "Basic React Setup and Tools."
      ]
    },
    {
      title: "Module 2: React Components",
      content: [
        "Understanding React Components",
        "Functional vs Class Components",
        "Props and State in React Components",
        "Lifecycle Methods in Class Components."
      ]
    },
    {
      title: "Module 3: JSX and Rendering",
      content: [
        "What is JSX?",
        "How JSX gets converted into React Elements.",
        "Rendering JSX to the DOM.",
        "JSX Expressions and Best Practices."
      ]
    },
    {
      title: "Module 4: State Management",
      content: [
        "Introduction to State in React",
        "Using useState Hook for functional components.",
        "Managing state in Class Components.",
        "Passing data between Components via Props."
      ]
    },
    {
      title: "Module 5: Handling Events in React",
      content: [
        "Event Handling in React Components",
        "Synthetic Events in React",
        "Handling User Input and Forms.",
        "Form Validation and Error Handling."
      ]
    },
    {
      title: "Module 6: React Router",
      content: [
        "Introduction to React Router",
        "Setting up Routes and Navigation in React.",
        "React Router Hooks: useHistory, useLocation, etc.",
        "Dynamic Routing and Nested Routes."
      ]
    },
    {
      title: "Module 7: Hooks in React",
      content: [
        "Introduction to React Hooks",
        "useEffect Hook: Managing side effects.",
        "useContext Hook: Accessing Global State.",
        "Custom Hooks: Reusing logic across components."
      ]
    },
    {
      title: "Module 8: Error Boundaries",
      content: [
        "What are Error Boundaries in React?",
        "How to Implement Error Boundaries.",
        "Catching JavaScript Errors in React Components.",
        "Displaying fallback UI on errors."
      ]
    },
    {
      title: "Module 9: Performance Optimization",
      content: [
        "Optimizing React Components for Performance.",
        "React.memo and PureComponent.",
        "Code Splitting and Lazy Loading.",
        "Debouncing and Throttling Techniques."
      ]
    },
    {
      title: "Module 10: Testing in React",
      content: [
        "Testing React Components with Jest.",
        "Using React Testing Library.",
        "Writing Unit Tests for React Components.",
        "Mocking Data and API Calls in Tests."
      ]
    },
    {
      title: "Module 11: Building and Deploying React Applications",
      content: [
        "Building React App for Production.",
        "Deployment with Netlify, Vercel, or Heroku.",
        "Configuring Build Settings for Optimized Output.",
        "Continuous Integration and Deployment (CI/CD) in React."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">React Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px', color: '#333' }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ReactModule;
